import $ from 'jquery';
import 'slick-carousel';
import SlickPlayPauseControls from './SlickPlayPauseControls';

const defaults = {
  speed: 500,
  fade: true,
  slide: '.field-image, a',
  autoplay: true,
  autoplaySpeed: 4000,
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 690,
      settings: {
        arrows: false,
      },
    },
  ],
};

function Gallery(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.$slickContainer = this.addSlick();
  this.controls = this.addControls();
  this.ready();
}

Gallery.prototype = {
  addSlick() {
    return this.$element.slick(this.settings);
  },
  ready() {
    this.$element.addClass('ready');
  },
  addControls() {
    return new SlickPlayPauseControls(this.$slickContainer, { attachTo: this.$element });
  },
};

export default Gallery;



// WEBPACK FOOTER //
// ./Gallery.js